import React from 'react';
import { useIntl } from 'react-intl';

import { FieldBlock, FieldInput } from '../../ui';
import { CustomStorageFieldTypes, MappingFieldsList } from './settings';
import { MapDivider, MappingInputWrapper, MapWrapper } from './style';

type Props = {
  fieldName: CustomStorageFieldTypes;
};

export const MappingFields = (props: Props): JSX.Element => {
  const intl = useIntl();
  const { fieldName } = props;
  return (
    <FieldBlock
      title={intl.formatMessage({ id: 'enterprise-connection.settings.map.title' })}
      description={intl.formatMessage({
        id: 'enterprise-connection.settings.map.description'
      })}
      notification={intl.formatMessage({
        id: 'enterprise-connection.settings.map.notification'
      })}
      key={`${fieldName}_map_field`}>
      {MappingFieldsList.map((item) => {
        return (
          <MapWrapper key={`${item}_map_input`}>
            <MappingInputWrapper>
              <FieldInput name={`xsolla_${item}`} value={item.substring(8)} disabled />
            </MappingInputWrapper>
            <MapDivider />
            <MappingInputWrapper>
              <FieldInput
                name={`${fieldName}_${item}`}
                data-test-id={`custom_storage_field_${fieldName}_$${item}`}
              />
            </MappingInputWrapper>
          </MapWrapper>
        );
      })}
    </FieldBlock>
  );
};
